<template>
  <div class="pb-3">
    <va-card :title="$t('sena.notify.title', { number: edition.edition_number })">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(send)">
          <div class="row">
            <div class="flex md12">
              <va-select
                v-model="moment"
                text-by="label"
                key-by="id"
                :options="moments"
                clearable="false"
                noOptionsText="Sem Items"
                :label="$t('sena.notify.momentLabel')"
                :placeholder="$t('sena.notify.momentPlaceholder')"
              />
              <ValidationProvider rules="required" name="Titulo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.title"
                  :label="$t('sendNotification.forms.titleLabel')"
                  :placeholder="$t('sendNotification.forms.titlePlaceholder')"
                  :success="errors.length == 0 && notificacao.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Corpo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.subtitle"
                  type="textarea"
                  :label="$t('sendNotification.forms.bodyLabel')"
                  :placeholder="$t('sendNotification.forms.bodyPlaceholder')"
                  :success="errors.length == 0 && notificacao.subtitle.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Link" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.url"
                  :label="$t('sena.notify.urlLabel')"
                  :placeholder="$t('sena.notify.urlPlaceholder')"
                  :success="errors.length == 0 && notificacao.url.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <!--
                Disparo nativo: o app abre diretamente a tela da Sena (/start/sena/)
                usando a estratégia SenaPush. A url vai junto no payload para servir
                de fallback seguro para web ou versões anteriores.
              -->
              <p class="mt-2 mb-0">
                <small>{{ $t('sena.notify.typeHint') }}</small>
              </p>
            </div>
            <div class="d-flex mt-1">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
              <va-button
                type="button"
                class="my-0"
                color="danger"
                @click="cancel">
                {{ $t("forms.cancel") }}
              </va-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
const MOMENT_IDS = ['opened', 'reminder', 'scored', 'winners']

export default {
  name: 'sena-send-notification',
  props: {
    edition: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      moment: null,
      notificacao: {
        title: '',
        subtitle: '',
        url: this.senaUrl(),
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  computed: {
    moments () {
      return MOMENT_IDS.map(id => ({
        id,
        label: this.$t(`sena.notify.moments.${id}.label`),
      }))
    },
    // O que o texto padrão pode citar. `alive` só existe depois que o
    // andamento foi carregado — sem ele o texto de "placar apurado" sairia
    // com "undefined sobreviventes".
    params () {
      const progress = this.edition.progress || {}
      return {
        number: this.edition.edition_number,
        name: this.edition.name,
        prize: Number(this.edition.prize_amount || 0)
          .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        prize5: Number(this.edition.prize_amount_5 || 0)
          .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        lockout: this.edition.lockout_at
          ? this.$moment(this.edition.lockout_at).format('DD/MM [às] HH:mm')
          : '',
        alive: progress.tickets_alive != null ? progress.tickets_alive : 0,
        total: progress.tickets_total != null ? progress.tickets_total : 0,
        winners: this.edition.total_winners || 0,
        winners5: this.edition.total_winners_5 || 0,
      }
    },
  },
  watch: {
    moment (value) {
      if (!value) return
      // Preenche, não trava: o texto continua editável antes de enviar.
      this.notificacao.title = this.$t(`sena.notify.moments.${value.id}.title`, this.params)
      this.notificacao.subtitle = this.$t(`sena.notify.moments.${value.id}.body`, this.params)
    },
  },
  methods: {
    senaUrl () {
      if (process.env.VUE_APP_SENA_URL) return process.env.VUE_APP_SENA_URL
      const base = process.env.VUE_APP_LINK || 'https://s1live.com'
      return `${base.replace(/\/$/, '')}/sena`
    },
    cancel () {
      this.$emit('close', false)
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      this.$axios.post(
        '/api/messaging/sena',
        {
          title: this.notificacao.title,
          body: this.notificacao.subtitle,
          url: this.notificacao.url,
          edition_id: String(this.edition.id),
          type: 'sena',
          indice: '1',
        },
      ).then(() => {
        self.buttonSubmitDisabled = false
        self.textSubmit = self.$t('forms.send')
        self.$emit('close', false)
        self.showToast(
          self.$t('toasts.successSend'),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      })
        .catch(() => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.send')
          self.showToast(
            self.$t('toasts.errorSend'),
            {
              icon: 'fa-exclamation-triangle',
              position: 'top-right',
              duration: 2500,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
